//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Swiper from 'swiper'
export default {
  data() {
    return {
      scrollTop: 0,
      old: {
        scrollTop: 0
      }
    }
  },
  props: {
    viewspotInfo: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    scroll: function (e) {
      console.log(e)
      this.old.scrollTop = e.detail.scrollTop
    },
    handleClick(item) {
      uni.navigateTo({
        url: '/pages/scenicTutorials/components/spotDetail?id=' + item.id
      })
    }
  }
}
